export default "__VITE_ASSET__BMpTEHm7__"